import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://api.airtable.com/v0/appKm06fM103Z9fGg/Slideshow'
})

const airtableAPIKey = process.env.VUE_APP_AIRTABLEKEY
Axios.defaults.headers.common = { Authorization: 'Bearer ' + airtableAPIKey }

export default {
  getSlideshow () {
    const slideshow = Axios.get('?')
    return slideshow
  }
}
